import React from 'react';

export const IconViewer = () => {
  // @ts-ignore
  return (
    <>
      <div
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: 'white'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 10,
            padding: 30
          }}
        >
          {Object.keys(icons).map((i) => (
            <div className="d-center" style={{ width: 120, height: 80 }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 5
                }}
              >
                <Icon icon={i} size={48} fill="var(--color-secondary)" />
                <span>{i}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

interface IconProps {
  className?: string;
  fill?: string;
  size?: number;
  height?: number;
  marginLeft?: number;
  margin?: number;
  icon: string;
}

export const Icon = ({ className, fill, size, height, icon, marginLeft, margin }: IconProps) => (
  <div
    className={className}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: fill,
      width: size || 16,
      height: height || size || 16,
      marginLeft: marginLeft || 0,
      marginRight: margin || 0
    }}
  >
    {icons[icon]}
  </div>
);

const icons = {
  Hamburger: (
    <svg viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 12H17C17.55 12 18 11.55 18 11C18 10.45 17.55 10 17 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12ZM1 7H17C17.55 7 18 6.55 18 6C18 5.45 17.55 5 17 5H1C0.45 5 0 5.45 0 6C0 6.55 0.45 7 1 7ZM0 1C0 1.55 0.45 2 1 2H17C17.55 2 18 1.55 18 1C18 0.45 17.55 0 17 0H1C0.45 0 0 0.45 0 1Z"
        fill="currentColor"
      />
    </svg>
  ),
  Close: (
    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.61305 4.54125L8.85723 1.29146C8.98353 1.14647 9.04997 0.958882 9.0431 0.766721C9.03623 0.574559 8.95657 0.392196 8.82025 0.256588C8.68392 0.120979 8.50115 0.0422705 8.30895 0.0364116C8.11676 0.0305527 7.92952 0.0979822 7.78519 0.225035L4.54101 3.46922L1.29122 0.225035C1.22171 0.154097 1.13875 0.0977403 1.04719 0.059267C0.955633 0.0207936 0.857318 0.000976562 0.758004 0.000976562C0.65869 0.000976563 0.560375 0.0207936 0.468816 0.059267C0.377257 0.0977403 0.294296 0.154097 0.224791 0.225035C0.153852 0.29454 0.0974962 0.377501 0.0590228 0.46906C0.0205494 0.560619 0.000732422 0.658934 0.000732422 0.758248C0.000732422 0.857562 0.0205494 0.955877 0.0590228 1.04744C0.0974962 1.13899 0.153852 1.22196 0.224791 1.29146L3.46897 4.54125L0.224791 7.78544C0.154361 7.85581 0.0984902 7.93936 0.0603707 8.03134C0.0222512 8.12331 0.00263068 8.2219 0.00263068 8.32146C0.00263068 8.42101 0.0222512 8.5196 0.0603707 8.61157C0.0984902 8.70355 0.154361 8.78711 0.224791 8.85747C0.298004 8.93095 0.385728 8.98837 0.482366 9.02606C0.579005 9.06375 0.682438 9.08088 0.786068 9.07637C0.985702 9.0765 1.17732 8.99783 1.31928 8.85747L4.54101 5.61329L7.78519 8.86309C7.8592 8.93548 7.94705 8.99218 8.0435 9.02979C8.13995 9.06741 8.243 9.08516 8.34647 9.08199C8.5461 9.08211 8.73772 9.00345 8.87968 8.86309C9.02056 8.72025 9.09954 8.52769 9.09954 8.32707C9.09954 8.12644 9.02056 7.93389 8.87968 7.79105L5.61305 4.54125Z"
        fill="currentColor"
      />
    </svg>
  ),
  Arrow: (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0012 1L15 6L10.0012 11M1 6H14.86"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Wallet: (
    <svg fill="currentColor" viewBox="-0.32 -0.32 32.64 32.64" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <title>wallet</title>
        <path d="M18 22c-1.104 0-2-0.896-2-2v-2c0-1.105 0.896-2 2-2h12v6h-12zM19.5 17.583c-0.828 0-1.5 0.672-1.5 1.5 0 0.829 0.672 1.5 1.5 1.5 0.829 0 1.5-0.671 1.5-1.5 0-0.828-0.671-1.5-1.5-1.5zM15 18v2c0 1.656 1.344 3 3 3h10v4c0 1.656-1.343 3-3 3h-21c-1.656 0-3-1.344-3-3v-19c0-1.657 1.344-3 3-3h9.632l-2.349 0.979h-7.782c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h24.499v6.021h-10c-1.656 0-3 1.343-3 3zM5.001 11h-2v2h1v-1h1v-1zM5.001 14h-2v2h1.041l-0.041-1 1 0.021v-1.021zM5.001 17h-2v2h1.021l-0.021-1h1v-1zM5.001 20h-2v2h1.021l-0.021-1 1 0.021v-1.021zM5.001 23h-2v2h1v-1h1v-1zM5.001 26h-2v2h1.021l-0.021-0.979h1v-1.021zM9.001 7.938l11.75-4.938 2.25 4.938h-14zM22.646 5h2.354c0.876 0 1.656 0.381 2.205 0.979h-4.081l-0.478-0.979z"></path>
      </g>
    </svg>
  ),
  Check: (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5.375L3.72727 8L11 1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Google: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.6002 9.2H11.2002V12.9H16.7002C16.6002 13.8 16.0002 15.2 14.7002 16.1C13.9002 16.7 12.7002 17.1 11.2002 17.1C8.6002 17.1 6.3002 15.4 5.5002 12.9C5.3002 12.3 5.2002 11.6 5.2002 10.9C5.2002 10.2 5.3002 9.5 5.5002 8.9C5.6002 8.7 5.6002 8.5 5.7002 8.4C6.6002 6.3 8.7002 4.8 11.2002 4.8C13.1002 4.8 14.3002 5.6 15.1002 6.3L17.9002 3.5C16.2002 2 13.9002 1 11.2002 1C7.3002 1 3.9002 3.2 2.3002 6.5C1.6002 7.9 1.2002 9.4 1.2002 11C1.2002 12.6 1.6002 14.1 2.3002 15.5C3.9002 18.8 7.3002 21 11.2002 21C13.9002 21 16.2002 20.1 17.8002 18.6C19.7002 16.9 20.8002 14.3 20.8002 11.2C20.8002 10.4 20.7002 9.8 20.6002 9.2Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Exchange: (
    <svg width="62" height="63" viewBox="0 0 62 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_138_275"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="62"
        height="63"
      >
        <path d="M0 0H62V63H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_138_275)">
        <path
          d="M18.4531 22.2163H4.88046C4.37057 22.217 3.86554 22.1176 3.39435 21.9238C2.92315 21.73 2.49503 21.4457 2.13455 21.0871C1.77406 20.7284 1.48829 20.3026 1.29361 19.8339C1.09893 19.3652 0.99918 18.8629 1.00007 18.3558V4.85506C0.99918 4.34797 1.09893 3.84569 1.29361 3.37701C1.48829 2.90833 1.77406 2.48247 2.13455 2.12383C2.49503 1.7652 2.92315 1.48085 3.39435 1.28708C3.86554 1.09331 4.37057 0.993928 4.88046 0.994635H18.4531C18.9631 0.993752 19.4682 1.093 19.9396 1.28669C20.4109 1.48039 20.8392 1.76471 21.1999 2.12336C21.5605 2.48201 21.8464 2.90793 22.0411 3.3767C22.2359 3.84546 22.3357 4.34785 22.3348 4.85506V18.3558C22.3357 18.863 22.2359 19.3654 22.0411 19.8342C21.8464 20.303 21.5605 20.7289 21.1999 21.0875C20.8392 21.4462 20.4109 21.7305 19.9396 21.9242C19.4682 22.1179 18.9631 22.2171 18.4531 22.2163ZM57.1209 62.0054H43.5482C43.0382 62.0063 42.5331 61.9071 42.0617 61.7134C41.5904 61.5197 41.1621 61.2354 40.8015 60.8767C40.4408 60.5181 40.1549 60.0922 39.9602 59.6234C39.7654 59.1546 39.6656 58.6522 39.6665 58.145V44.6443C39.6656 44.137 39.7654 43.6347 39.9602 43.1659C40.1549 42.6971 40.4408 42.2712 40.8015 41.9126C41.1621 41.5539 41.5904 41.2696 42.0617 41.0759C42.5331 40.8822 43.0382 40.7829 43.5482 40.7838H57.1209C57.6307 40.7831 58.1358 40.8825 58.607 41.0763C59.0782 41.27 59.5063 41.5544 59.8668 41.913C60.2272 42.2717 60.513 42.6975 60.7077 43.1662C60.9024 43.6349 61.0021 44.1372 61.0012 44.6443V58.1464C61.0019 58.6535 60.902 59.1557 60.7072 59.6243C60.5123 60.0929 60.2264 60.5187 59.8658 60.8772C59.5052 61.2357 59.077 61.5199 58.6057 61.7135C58.1344 61.9071 57.6307 62.0063 57.1209 62.0054Z"
          stroke="#F9F9FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6667 15.5838C11.1412 15.5845 10.6207 15.4821 10.135 15.2824C9.64936 15.0828 9.20809 14.7897 8.83648 14.4202C8.46487 14.0506 8.17024 13.6118 7.96945 13.1288C7.76867 12.6458 7.66568 12.1281 7.66639 11.6055C7.6655 11.0827 7.76836 10.5649 7.96906 10.0818C8.16977 9.5986 8.46438 9.15959 8.836 8.78988C9.20763 8.42017 9.64896 8.12703 10.1347 7.92726C10.6205 7.7275 11.1411 7.62503 11.6667 7.62574C12.1924 7.62503 12.713 7.7275 13.1988 7.92726C13.6845 8.12703 14.1258 8.42017 14.4975 8.78988C14.8691 9.15959 15.1637 9.5986 15.3644 10.0818C15.5651 10.5649 15.668 11.0827 15.6671 11.6055C15.6678 12.1281 15.5648 12.6458 15.364 13.1288C15.1632 13.6118 14.8686 14.0506 14.497 14.4202C14.1254 14.7897 13.6841 15.0828 13.1984 15.2824C12.7128 15.4821 12.1923 15.5845 11.6667 15.5838Z"
          stroke="#F9F9FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.3346 54.0473C50.6898 54.0552 51.0431 53.9925 51.3736 53.8628C51.7041 53.7331 52.0052 53.539 52.2593 53.292C52.5134 53.0449 52.7152 52.7499 52.8531 52.4242C52.9909 52.0984 53.0619 51.7486 53.0619 51.3953C53.0619 51.0419 52.9909 50.6921 52.8531 50.3664C52.7152 50.0406 52.5134 49.7456 52.2593 49.4985C52.0052 49.2515 51.7041 49.0574 51.3736 48.9277C51.0431 48.798 50.6898 48.7353 50.3346 48.7432C49.6377 48.7588 48.9747 49.0451 48.4873 49.5407C48 50.0364 47.7272 50.702 47.7272 51.3953C47.7272 52.0885 48 52.7541 48.4873 53.2498C48.9747 53.7455 49.6377 54.0317 50.3346 54.0473Z"
          fill="#F9F9FF"
        />
        <path
          d="M39.6665 51.3947H11.6667V27.5217M22.3334 11.6055H50.3332V36.8055"
          stroke="#F9F9FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9192 34.2332L11.7732 26.3019L6.27948 34.1005M45.1858 28.8742L50.3332 36.8055L55.8269 29.0069"
          stroke="#F9F9FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  Market: (
    <svg width="63" height="55" viewBox="0 0 63 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_138_285"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="63"
        height="55"
      >
        <path d="M0 0H63V55H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_138_285)">
        <path
          d="M31.5952 0.887207C46.4715 0.887207 58.5235 12.7971 58.5235 27.5M31.5952 54.1129C16.7212 54.1129 4.66919 42.2018 4.66919 27.5M39.3751 51.7479C46.6462 51.7479 52.5397 45.9226 52.5397 38.7368C52.5397 31.5509 46.6462 25.7257 39.3751 25.7257C32.1039 25.7257 26.2104 31.5509 26.2104 38.7368C26.2104 45.9226 32.1039 51.7479 39.3751 51.7479Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.375 43.4668C42.0186 43.4668 44.1618 41.3493 44.1618 38.7356C44.1618 36.1231 42.0186 34.0044 39.375 34.0044C36.7314 34.0044 34.5882 36.1231 34.5882 38.7356C34.5882 41.3493 36.7314 43.4668 39.375 43.4668ZM23.8164 30.4569C31.0875 30.4569 36.981 24.6317 36.981 17.4458C36.981 10.2599 31.0875 4.43591 23.8164 4.43591C16.5452 4.43591 10.6517 10.2611 10.6517 17.447C10.6517 24.6329 16.5452 30.4569 23.8164 30.4569Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.8164 19.812C25.1382 19.812 26.2104 18.7527 26.2104 17.4458C26.2104 16.1402 25.1382 15.0808 23.8164 15.0808C22.4946 15.0808 21.4224 16.1402 21.4224 17.4458C21.4224 18.7527 22.4946 19.812 23.8164 19.812Z"
          fill="white"
        />
        <path
          d="M54.6091 23.6667L58.2239 29.2385L62.1014 23.7863M8.40159 32.3615L4.78801 26.7898L0.897461 32.2539"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  Profit: (
    <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_138_263)">
        <mask
          id="mask0_138_263"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="55"
          height="54"
        >
          <path d="M0 0H55V54H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_138_263)">
          <path
            d="M27.5344 40.3012C19.8814 40.3012 13.6755 34.2072 13.6755 26.6932C13.6755 19.1792 19.8814 13.0852 27.5355 13.0852C35.1897 13.0852 41.3955 19.178 41.3955 26.6932C41.3955 34.2072 35.1874 40.3012 27.5344 40.3012Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.7614 21.6001C30.7656 20.6786 29.1901 20.1892 27.4427 20.1892C24.86 20.1892 22.6371 21.7023 22.6371 23.4981C22.6371 25.2939 24.86 26.8059 27.4427 26.8059C30.0243 26.8059 32.2483 28.319 32.2483 30.1148C32.2483 31.9106 30.0254 33.4238 27.4427 33.4238C25.6942 33.4238 24.1198 32.9343 23.1229 32.0129M27.4427 17.3938V36.2191"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.5 53.1475V40.3346M54.1315 27H41.4287M27.5 0.852518V13.0519M0.86853 27H13.64M27.508 0.85022L0.874259 27L27.508 53.1498L54.1406 27L27.508 0.85022Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_138_263">
          <rect width="55" height="54" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  User: (
    <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 14.75V13.25C13 12.4544 12.6839 11.6913 12.1213 11.1287C11.5587 10.5661 10.7956 10.25 10 10.25H4C3.20435 10.25 2.44129 10.5661 1.87868 11.1287C1.31607 11.6913 1 12.4544 1 13.25V14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7.25C8.65685 7.25 10 5.90685 10 4.25C10 2.59315 8.65685 1.25 7 1.25C5.34315 1.25 4 2.59315 4 4.25C4 5.90685 5.34315 7.25 7 7.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Send: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_193_817)">
        <path
          d="M14.6667 1.33337L7.33337 8.66671"
          stroke="#7B4DD9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6667 1.33337L10 14.6667L7.33337 8.66671L1.33337 6.00004L14.6667 1.33337Z"
          stroke="#7B4DD9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_193_817">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Linkedin: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3334 6.66675C14.6595 6.66675 15.9312 7.19353 16.8689 8.13121C17.8066 9.0689 18.3334 10.3407 18.3334 11.6667V17.5001H15V11.6667C15 11.2247 14.8244 10.8008 14.5119 10.4882C14.1993 10.1757 13.7754 10.0001 13.3334 10.0001C12.8913 10.0001 12.4674 10.1757 12.1549 10.4882C11.8423 10.8008 11.6667 11.2247 11.6667 11.6667V17.5001H8.33337V11.6667C8.33337 10.3407 8.86016 9.0689 9.79784 8.13121C10.7355 7.19353 12.0073 6.66675 13.3334 6.66675Z"
        stroke="#F1F1FE"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99996 7.5H1.66663V17.5H4.99996V7.5Z"
        stroke="#F1F1FE"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33329 5.00008C4.25377 5.00008 4.99996 4.25389 4.99996 3.33341C4.99996 2.41294 4.25377 1.66675 3.33329 1.66675C2.41282 1.66675 1.66663 2.41294 1.66663 3.33341C1.66663 4.25389 2.41282 5.00008 3.33329 5.00008Z"
        stroke="#F1F1FE"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  FaceBook: (
    <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 0.777344H9C7.67392 0.777344 6.40215 1.29061 5.46447 2.20424C4.52678 3.11786 4 4.357 4 5.64906V8.57209H1V12.4695H4V20.2642H8V12.4695H11L12 8.57209H8V5.64906C8 5.39065 8.10536 5.14282 8.29289 4.9601C8.48043 4.77737 8.73478 4.67472 9 4.67472H12V0.777344Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  YouTobe: (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.688 4.03247C22.5692 3.57006 22.3273 3.14638 21.9867 2.80422C21.6461 2.46206 21.2188 2.21355 20.748 2.08378C19.028 1.67456 12.148 1.67456 12.148 1.67456C12.148 1.67456 5.26803 1.67456 3.54803 2.12276C3.07728 2.25253 2.65001 2.50104 2.30938 2.84319C1.96875 3.18535 1.72682 3.60903 1.60803 4.07145C1.29325 5.77222 1.13927 7.49754 1.14803 9.22572C1.13681 10.9669 1.2908 12.7054 1.60803 14.419C1.73899 14.867 1.98634 15.2746 2.32618 15.6023C2.66601 15.93 3.08685 16.1668 3.54803 16.2897C5.26803 16.7379 12.148 16.7379 12.148 16.7379C12.148 16.7379 19.028 16.7379 20.748 16.2897C21.2188 16.1599 21.6461 15.9114 21.9867 15.5693C22.3273 15.2271 22.5692 14.8034 22.688 14.341C23.0004 12.6531 23.1544 10.9409 23.148 9.22572C23.1593 7.48453 23.0053 5.74605 22.688 4.03247V4.03247Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.89844 12.4118L15.6484 9.22565L9.89844 6.03955V12.4118Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Instagram: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1484 1.72583H6.14844C3.38701 1.72583 1.14844 3.90697 1.14844 6.59755V16.341C1.14844 19.0316 3.38701 21.2127 6.14844 21.2127H16.1484C18.9099 21.2127 21.1484 19.0316 21.1484 16.341V6.59755C21.1484 3.90697 18.9099 1.72583 16.1484 1.72583Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1481 10.8555C15.2716 11.6664 15.1294 12.4945 14.7419 13.2222C14.3544 13.9498 13.7413 14.5399 12.9898 14.9084C12.2383 15.277 11.3866 15.4053 10.5559 15.275C9.72527 15.1448 8.95791 14.7627 8.36298 14.183C7.76806 13.6034 7.37588 12.8557 7.24221 12.0463C7.10855 11.237 7.24021 10.4072 7.61847 9.67494C7.99673 8.9427 8.60233 8.34532 9.34913 7.96776C10.0959 7.59021 10.9459 7.4517 11.7781 7.57195C12.6271 7.6946 13.413 8.08003 14.0198 8.6713C14.6267 9.26258 15.0223 10.0283 15.1481 10.8555Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Eye: (
    <svg
      fill="currentColor"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 519.578 519.578"
      stroke="currentColor"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="1.039156"
      />
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M513.095,245.101c0,0-140.683-139.842-253.291-139.842c-112.608,0-253.292,139.842-253.292,139.842 c-8.645,8.109-8.721,21.42,0,29.375c0,0,140.684,139.843,253.292,139.843c112.608,0,253.291-139.843,253.291-139.843 C521.663,266.368,521.816,253.134,513.095,245.101z M260.875,372.397c-61.889,0-112.149-50.185-112.149-112.149 s50.184-112.149,112.149-112.149c61.965,0,112.148,50.26,112.148,112.149S322.763,372.397,260.875,372.397z" />{' '}
            <path d="M259.574,187.726c-39.321,0-71.222,32.053-71.222,71.451c0,39.397,31.901,71.451,71.222,71.451 c39.321,0,71.222-32.054,71.222-71.451C330.796,219.78,298.896,187.726,259.574,187.726z M286.426,259.407 c-12.163,0-22.108-9.946-22.108-22.262s9.945-22.261,22.108-22.261s22.108,9.945,22.108,22.261S298.742,259.407,286.426,259.407z" />{' '}
          </g>
        </g>
      </g>
    </svg>
  ),
  NoEye: (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.95 14.9499C13.5255 16.0358 11.791 16.6373 10 16.6666C4.16671 16.6666 0.833374 9.99992 0.833374 9.99992C1.86995 8.06817 3.30765 6.38043 5.05004 5.04992M8.25004 3.53325C8.82365 3.39898 9.41093 3.33187 10 3.33325C15.8334 3.33325 19.1667 9.99992 19.1667 9.99992C18.6609 10.9463 18.0576 11.8372 17.3667 12.6583M11.7667 11.7666C11.5378 12.0122 11.2618 12.2092 10.9552 12.3459C10.6485 12.4825 10.3175 12.556 9.98178 12.5619C9.64611 12.5678 9.31268 12.5061 9.00138 12.3803C8.69009 12.2546 8.40731 12.0674 8.16991 11.83C7.93252 11.5927 7.74537 11.3099 7.61963 10.9986C7.4939 10.6873 7.43215 10.3539 7.43807 10.0182C7.44399 9.6825 7.51746 9.35146 7.6541 9.04479C7.79074 8.73813 7.98775 8.46213 8.23337 8.23325M0.833374 0.833252L19.1667 19.1666"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Email: (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8248 18.9484H5.17484C2.8915 18.9484 1.0415 17.09 1.0415 14.8067V8.63172C1.0415 7.49838 1.7415 6.07338 2.6415 5.37338L7.13317 1.87338C8.48317 0.823383 10.6415 0.773383 12.0415 1.75672L17.1915 5.36505C18.1832 6.05672 18.9582 7.54005 18.9582 8.74838V14.8151C18.9582 17.09 17.1082 18.9484 14.8248 18.9484ZM7.89984 2.85672L3.40817 6.35672C2.8165 6.82338 2.2915 7.88172 2.2915 8.63172V14.8067C2.2915 15.5722 2.59501 16.3064 3.1355 16.8485C3.676 17.3905 4.40936 17.6962 5.17484 17.6984H14.8248C16.4165 17.6984 17.7082 16.4067 17.7082 14.8151V8.74838C17.7082 7.94838 17.1332 6.84005 16.4748 6.39005L11.3248 2.78172C10.3748 2.11505 8.80817 2.14838 7.89984 2.85672Z"
        fill="currentColor"
      />
      <path d="M2 7.5L10 13.5L17.5 7.5" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  ),
  Password: (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.1835 16.875H6.25016C5.62516 16.875 5.16683 16.85 4.77516 16.7917C2.00016 16.4833 1.4585 14.8333 1.4585 12.0833V7.91667C1.4585 5.16667 2.0085 3.50833 4.80016 3.2C5.16683 3.15 5.62516 3.125 6.25016 3.125H9.1335C9.47516 3.125 9.7585 3.40833 9.7585 3.75C9.7585 4.09167 9.47516 4.375 9.1335 4.375H6.25016C5.6835 4.375 5.2835 4.4 4.9585 4.44167C3.26683 4.625 2.7085 5.15833 2.7085 7.91667V12.0833C2.7085 14.8417 3.26683 15.3667 4.9335 15.5583C5.2835 15.6083 5.6835 15.625 6.25016 15.625H9.1835C9.52516 15.625 9.8085 15.9083 9.8085 16.25C9.8085 16.5917 9.52516 16.875 9.1835 16.875ZM13.7502 16.875H12.5168C12.1752 16.875 11.8918 16.5917 11.8918 16.25C11.8918 15.9083 12.1752 15.625 12.5168 15.625H13.7502C14.3168 15.625 14.7168 15.6 15.0418 15.5583C16.7335 15.375 17.2918 14.8417 17.2918 12.0833V7.91667C17.2918 5.15833 16.7335 4.63333 15.0668 4.44167C14.7168 4.39167 14.3168 4.375 13.7502 4.375H12.5168C12.1752 4.375 11.8918 4.09167 11.8918 3.75C11.8918 3.40833 12.1752 3.125 12.5168 3.125H13.7502C14.3752 3.125 14.8335 3.15 15.2252 3.20833C18.0002 3.51667 18.5418 5.16667 18.5418 7.91667V12.0833C18.5418 14.8333 17.9918 16.4917 15.2002 16.8C14.8335 16.85 14.3752 16.875 13.7502 16.875Z"
        fill="currentColor"
      />
      <path
        d="M12.5001 18.9583C12.1584 18.9583 11.8751 18.675 11.8751 18.3333V1.66663C11.8751 1.32496 12.1584 1.04163 12.5001 1.04163C12.8418 1.04163 13.1251 1.32496 13.1251 1.66663V18.3333C13.1251 18.675 12.8418 18.9583 12.5001 18.9583ZM5.58343 10.8333C5.47509 10.8333 5.36676 10.8083 5.26676 10.7666C5.16676 10.725 5.07509 10.6666 4.99176 10.5916C4.91676 10.5083 4.85009 10.4166 4.80843 10.3166C4.76829 10.216 4.74846 10.1083 4.75009 9.99996C4.75009 9.78329 4.84176 9.56663 4.99176 9.40829C5.30009 9.09996 5.85843 9.09996 6.17509 9.40829C6.32509 9.56663 6.41676 9.78329 6.41676 9.99996C6.41676 10.1083 6.39176 10.2166 6.35009 10.3166C6.30843 10.4166 6.25009 10.5083 6.17509 10.5916C6.09176 10.6666 6.00009 10.725 5.90009 10.7666C5.80009 10.8083 5.69176 10.8333 5.58343 10.8333ZM8.91676 10.8333C8.80843 10.8333 8.70009 10.8083 8.60009 10.7666C8.50009 10.725 8.40843 10.6666 8.32509 10.5916C8.25009 10.5083 8.19176 10.4166 8.14176 10.3166C8.10843 10.2166 8.08343 10.1083 8.08343 9.99996C8.08343 9.78329 8.17509 9.56663 8.32509 9.40829C8.63343 9.09996 9.20009 9.09996 9.50843 9.40829C9.65843 9.56663 9.75009 9.78329 9.75009 9.99996C9.75009 10.1083 9.72509 10.2166 9.68343 10.3166C9.64176 10.4166 9.58343 10.5083 9.50843 10.5916C9.42509 10.6666 9.33343 10.725 9.23343 10.7666C9.13343 10.8083 9.02509 10.8333 8.91676 10.8333Z"
        fill="currentColor"
      />
    </svg>
  ),
  MetaMaskWallet: (
    <svg viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M39.0728 0L21.9092 12.6999L25.1009 5.21543L39.0728 0Z" fill="#E17726" />
      <path d="M0.966797 0.0151367L14.9013 5.21656L17.932 12.7992L0.966797 0.0151367Z" fill="#E27625" />
      <path d="M32.1656 27.0093L39.7516 27.1537L37.1004 36.1603L27.8438 33.6116L32.1656 27.0093Z" fill="#E27625" />
      <path d="M7.83409 27.0093L12.1399 33.6116L2.89876 36.1604L0.263672 27.1537L7.83409 27.0093Z" fill="#E27625" />
      <path
        d="M17.5203 10.8677L17.8304 20.8807L8.55371 20.4587L11.1924 16.4778L11.2258 16.4394L17.5203 10.8677Z"
        fill="#E27625"
      />
      <path
        d="M22.3831 10.7559L28.7737 16.4397L28.8067 16.4778L31.4455 20.4586L22.1709 20.8806L22.3831 10.7559Z"
        fill="#E27625"
      />
      <path d="M12.4115 27.0381L17.4768 30.9848L11.5928 33.8257L12.4115 27.0381Z" fill="#E27625" />
      <path d="M27.5893 27.0376L28.391 33.8258L22.5234 30.9847L27.5893 27.0376Z" fill="#E27625" />
      <path d="M22.6523 30.6128L28.6066 33.4959L23.0679 36.1282L23.1255 34.3884L22.6523 30.6128Z" fill="#D5BFB2" />
      <path d="M17.3458 30.6143L16.8913 34.3601L16.9286 36.1263L11.377 33.4961L17.3458 30.6143Z" fill="#D5BFB2" />
      <path d="M15.6263 22.1875L17.1822 25.4575L11.8848 23.9057L15.6263 22.1875Z" fill="#233447" />
      <path d="M24.3739 22.1875L28.133 23.9053L22.8184 25.4567L24.3739 22.1875Z" fill="#233447" />
      <path d="M12.8169 27.0049L11.9606 34.0423L7.37109 27.1587L12.8169 27.0049Z" fill="#CC6228" />
      <path d="M27.1836 27.0049L32.6296 27.1587L28.0228 34.0425L27.1836 27.0049Z" fill="#CC6228" />
      <path
        d="M31.5799 20.0605L27.6165 24.0998L24.5608 22.7034L23.0978 25.779L22.1387 20.4901L31.5799 20.0605Z"
        fill="#CC6228"
      />
      <path
        d="M8.41797 20.0605L17.8608 20.4902L16.9017 25.779L15.4384 22.7038L12.3988 24.0999L8.41797 20.0605Z"
        fill="#CC6228"
      />
      <path d="M8.15039 19.2314L12.6345 23.7816L12.7899 28.2736L8.15039 19.2314Z" fill="#E27525" />
      <path d="M31.8538 19.2236L27.2061 28.2819L27.381 23.7819L31.8538 19.2236Z" fill="#E27525" />
      <path
        d="M17.6412 19.5088L17.8217 20.6447L18.2676 23.4745L17.9809 32.166L16.6254 25.1841L16.625 25.1119L17.6412 19.5088Z"
        fill="#E27525"
      />
      <path
        d="M22.3562 19.4932L23.3751 25.1119L23.3747 25.1841L22.0158 32.1835L21.962 30.4328L21.75 23.4231L22.3562 19.4932Z"
        fill="#E27525"
      />
      <path
        d="M27.7797 23.6011L27.628 27.5039L22.8977 31.1894L21.9414 30.5138L23.0133 24.9926L27.7797 23.6011Z"
        fill="#F5841F"
      />
      <path
        d="M12.2373 23.6011L16.9873 24.9926L18.0591 30.5137L17.1029 31.1893L12.3723 27.5035L12.2373 23.6011Z"
        fill="#F5841F"
      />
      <path
        d="M10.4717 32.6338L16.5236 35.5013L16.4979 34.2768L17.0043 33.8323H22.994L23.5187 34.2753L23.48 35.4989L29.4935 32.641L26.5673 35.0591L23.0289 37.4894H16.9558L13.4197 35.0492L10.4717 32.6338Z"
        fill="#C0AC9D"
      />
      <path
        d="M22.2191 30.231L23.0748 30.8354L23.5763 34.8361L22.8506 34.2234H17.1513L16.4395 34.8485L16.9244 30.8357L17.7804 30.231H22.2191Z"
        fill="#161616"
      />
      <path
        d="M37.9395 0.351562L39.9998 6.53242L38.7131 12.7819L39.6293 13.4887L38.3895 14.4346L39.3213 15.1542L38.0875 16.2779L38.8449 16.8264L36.8347 19.1742L28.5894 16.7735L28.5179 16.7352L22.5762 11.723L37.9395 0.351562Z"
        fill="#763E1A"
      />
      <path
        d="M2.06031 0.351562L17.4237 11.723L11.4819 16.7352L11.4105 16.7735L3.16512 19.1742L1.15488 16.8264L1.91176 16.2783L0.678517 15.1542L1.60852 14.4354L0.350209 13.4868L1.30098 12.7795L0 6.53265L2.06031 0.351562Z"
        fill="#763E1A"
      />
      <path
        d="M28.1861 16.2485L36.9226 18.7921L39.7609 27.5398L32.2728 27.5398L27.1133 27.6049L30.8655 20.2912L28.1861 16.2485Z"
        fill="#F5841F"
      />
      <path
        d="M11.8139 16.2485L9.13399 20.2912L12.8867 27.6049L7.72971 27.5398H0.254883L3.07728 18.7922L11.8139 16.2485Z"
        fill="#F5841F"
      />
      <path
        d="M25.5283 5.17383L23.0847 11.7736L22.5661 20.6894L22.3677 23.4839L22.352 30.6225H17.6471L17.6318 23.4973L17.4327 20.6869L16.9139 11.7736L14.4707 5.17383H25.5283Z"
        fill="#F5841F"
      />
    </svg>
  ),
  MobileWallet: (
    <svg viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient cx="0%" cy="50%" fx="0%" fy="50%" r="100%" id="radialGradient-1">
          <stop stopColor="#5D9DF6" offset="0%"></stop>
          <stop stopColor="#006FFF" offset="100%"></stop>
        </radialGradient>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="logo">
          <rect id="base" fill="rgba(59, 130, 246)" x="0" y="0" width="512" height="512" rx="256"></rect>
          <path
            d="M169.209772,184.531136 C217.142772,137.600733 294.857519,137.600733 342.790517,184.531136 L348.559331,190.179285 C350.955981,192.525805 350.955981,196.330266 348.559331,198.676787 L328.82537,217.99798 C327.627045,219.171241 325.684176,219.171241 324.485851,217.99798 L316.547278,210.225455 C283.10802,177.485633 228.89227,177.485633 195.453011,210.225455 L186.951456,218.549188 C185.75313,219.722448 183.810261,219.722448 182.611937,218.549188 L162.877976,199.227995 C160.481326,196.881474 160.481326,193.077013 162.877976,190.730493 L169.209772,184.531136 Z M383.602212,224.489406 L401.165475,241.685365 C403.562113,244.031874 403.562127,247.836312 401.165506,250.182837 L321.971538,327.721548 C319.574905,330.068086 315.689168,330.068112 313.292501,327.721609 C313.292491,327.721599 313.29248,327.721588 313.29247,327.721578 L257.08541,272.690097 C256.486248,272.103467 255.514813,272.103467 254.915651,272.690097 C254.915647,272.690101 254.915644,272.690105 254.91564,272.690108 L198.709777,327.721548 C196.313151,330.068092 192.427413,330.068131 190.030739,327.721634 C190.030725,327.72162 190.03071,327.721606 190.030695,327.721591 L110.834524,250.181849 C108.437875,247.835329 108.437875,244.030868 110.834524,241.684348 L128.397819,224.488418 C130.794468,222.141898 134.680206,222.141898 137.076856,224.488418 L193.284734,279.520668 C193.883897,280.107298 194.85533,280.107298 195.454493,279.520668 C195.454502,279.520659 195.45451,279.520651 195.454519,279.520644 L251.65958,224.488418 C254.056175,222.141844 257.941913,222.141756 260.338618,224.488222 C260.338651,224.488255 260.338684,224.488288 260.338717,224.488321 L316.546521,279.520644 C317.145683,280.107273 318.117118,280.107273 318.71628,279.520644 L374.923175,224.489406 C377.319825,222.142885 381.205562,222.142885 383.602212,224.489406 Z"
            id="WalletConnect"
            fill="#FFFFFF"
            fillRule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
  ),
  CoinBaseWallet: (
    <svg viewBox="0 0 292 292" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M145.7 291.66C226.146 291.66 291.36 226.446 291.36 146C291.36 65.5541 226.146 0.339844 145.7 0.339844C65.2542 0.339844 0.0400391 65.5541 0.0400391 146C0.0400391 226.446 65.2542 291.66 145.7 291.66Z"
        fill="#3259A5"
      />
      <path
        d="M195.94 155.5C191.49 179.08 170.8 196.91 145.93 196.91C117.81 196.91 95.0204 174.12 95.0204 146C95.0204 117.88 117.81 95.0897 145.93 95.0897C170.8 95.0897 191.49 112.93 195.94 136.5H247.31C242.52 84.7197 198.96 44.1797 145.93 44.1797C89.6904 44.1797 44.1104 89.7697 44.1104 146C44.1104 202.24 89.7004 247.82 145.93 247.82C198.96 247.82 242.52 207.28 247.31 155.5H195.94Z"
        fill="white"
      />
    </svg>
  ),
  USDT: (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 339.43 295.27">
      <title>tether-usdt-logo</title>
      <path
        d="M62.15,1.45l-61.89,130a2.52,2.52,0,0,0,.54,2.94L167.95,294.56a2.55,2.55,0,0,0,3.53,0L338.63,134.4a2.52,2.52,0,0,0,.54-2.94l-61.89-130A2.5,2.5,0,0,0,275,0H64.45a2.5,2.5,0,0,0-2.3,1.45h0Z"
        style={{ fill: '#50af95', fillRule: 'evenodd' }}
      />
      <path
        d="M191.19,144.8v0c-1.2.09-7.4,0.46-21.23,0.46-11,0-18.81-.33-21.55-0.46v0c-42.51-1.87-74.24-9.27-74.24-18.13s31.73-16.25,74.24-18.15v28.91c2.78,0.2,10.74.67,21.74,0.67,13.2,0,19.81-.55,21-0.66v-28.9c42.42,1.89,74.08,9.29,74.08,18.13s-31.65,16.24-74.08,18.12h0Zm0-39.25V79.68h59.2V40.23H89.21V79.68H148.4v25.86c-48.11,2.21-84.29,11.74-84.29,23.16s36.18,20.94,84.29,23.16v82.9h42.78V151.83c48-2.21,84.12-11.73,84.12-23.14s-36.09-20.93-84.12-23.15h0Zm0,0h0Z"
        style={{ fill: '#fff', fillRule: 'evenodd' }}
      />
    </svg>
  ),
  USDC: (
    <svg data-name="86977684-12db-4850-8f30-233a7c267d11" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000">
      <path
        d="M1000 2000c554.17 0 1000-445.83 1000-1000S1554.17 0 1000 0 0 445.83 0 1000s445.83 1000 1000 1000z"
        fill="#2775ca"
      />
      <path
        d="M1275 1158.33c0-145.83-87.5-195.83-262.5-216.66-125-16.67-150-50-150-108.34s41.67-95.83 125-95.83c75 0 116.67 25 137.5 87.5 4.17 12.5 16.67 20.83 29.17 20.83h66.66c16.67 0 29.17-12.5 29.17-29.16v-4.17c-16.67-91.67-91.67-162.5-187.5-170.83v-100c0-16.67-12.5-29.17-33.33-33.34h-62.5c-16.67 0-29.17 12.5-33.34 33.34v95.83c-125 16.67-204.16 100-204.16 204.17 0 137.5 83.33 191.66 258.33 212.5 116.67 20.83 154.17 45.83 154.17 112.5s-58.34 112.5-137.5 112.5c-108.34 0-145.84-45.84-158.34-108.34-4.16-16.66-16.66-25-29.16-25h-70.84c-16.66 0-29.16 12.5-29.16 29.17v4.17c16.66 104.16 83.33 179.16 220.83 200v100c0 16.66 12.5 29.16 33.33 33.33h62.5c16.67 0 29.17-12.5 33.34-33.33v-100c125-20.84 208.33-108.34 208.33-220.84z"
        fill="#fff"
      />
      <path
        d="M787.5 1595.83c-325-116.66-491.67-479.16-370.83-800 62.5-175 200-308.33 370.83-370.83 16.67-8.33 25-20.83 25-41.67V325c0-16.67-8.33-29.17-25-33.33-4.17 0-12.5 0-16.67 4.16-395.83 125-612.5 545.84-487.5 941.67 75 233.33 254.17 412.5 487.5 487.5 16.67 8.33 33.34 0 37.5-16.67 4.17-4.16 4.17-8.33 4.17-16.66v-58.34c0-12.5-12.5-29.16-25-37.5zM1229.17 295.83c-16.67-8.33-33.34 0-37.5 16.67-4.17 4.17-4.17 8.33-4.17 16.67v58.33c0 16.67 12.5 33.33 25 41.67 325 116.66 491.67 479.16 370.83 800-62.5 175-200 308.33-370.83 370.83-16.67 8.33-25 20.83-25 41.67V1700c0 16.67 8.33 29.17 25 33.33 4.17 0 12.5 0 16.67-4.16 395.83-125 612.5-545.84 487.5-941.67-75-237.5-258.34-416.67-487.5-491.67z"
        fill="#fff"
      />
    </svg>
  ),
  Investor: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 122.88 111.09"
      xmlSpace="preserve"
    >
      <g>
        <path
          style={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
          d="M36.25,39.13c-1.13,0.05-1.99,0.28-2.57,0.67c-0.33,0.22-0.58,0.51-0.74,0.85c-0.17,0.38-0.26,0.84-0.24,1.37 c0.05,1.55,0.85,3.58,2.43,5.92l0.02,0.04l0,0l5.11,8.1c2.05,3.25,4.19,6.57,6.86,9.01c2.56,2.34,5.67,3.92,9.78,3.94 c4.45,0.01,7.71-1.64,10.35-4.11c2.75-2.57,4.92-6.1,7.06-9.62l5.74-9.47c1.08-2.44,1.46-4.08,1.21-5.04 c-0.15-0.57-0.77-0.86-1.85-0.9c-0.23-0.01-0.46-0.02-0.7-0.01c-0.26,0.01-0.52,0.03-0.8,0.05c-0.16,0.02-0.3,0-0.44-0.03 c-0.51,0.03-1.04-0.01-1.57-0.08l1.97-8.71c-14.61,2.3-25.53-8.55-40.97-2.17l1.11,10.27C37.38,39.23,36.79,39.21,36.25,39.13 L36.25,39.13L36.25,39.13L36.25,39.13z M122.09,90.14c0.51,0.85,0.79,1.76,0.79,2.71c0,5-7.74,9.06-17.28,9.06 c-9.54,0-17.28-4.06-17.28-9.06c0-0.94,0.28-1.85,0.79-2.71c2.2,3.68,8.75,6.35,16.49,6.35C113.35,96.49,119.9,93.82,122.09,90.14 L122.09,90.14L122.09,90.14z M111.84,71.42l-0.2,2.25l-8.48-0.74c0.7,0.89,1.18,1.91,1.45,3.05l-2.04-0.18 c-0.14-0.6-0.45-1.27-0.92-2c-0.48-0.74-1.06-1.26-1.76-1.58l0.16-1.82L111.84,71.42L111.84,71.42L111.84,71.42L111.84,71.42z M105.6,67.9c7.84,0,14.2,2.5,14.2,5.57c0,3.08-6.36,5.57-14.2,5.57c-7.84,0-14.2-2.5-14.2-5.57C91.4,70.39,97.76,67.9,105.6,67.9 L105.6,67.9L105.6,67.9z M105.6,66.05c9.54,0,17.28,4.06,17.28,9.06c0,5-7.74,9.06-17.28,9.06c-9.54,0-17.28-4.06-17.28-9.06 S96.06,66.05,105.6,66.05L105.6,66.05L105.6,66.05z M122.15,81.15c0.47,0.82,0.73,1.7,0.73,2.6c0,5-7.74,9.06-17.28,9.06 c-9.54,0-17.28-4.06-17.28-9.06c0-0.91,0.25-1.78,0.73-2.6c2.13,3.73,8.73,6.46,16.55,6.46C113.42,87.61,120.02,84.88,122.15,81.15 L122.15,81.15L122.15,81.15L122.15,81.15z M122.07,99.28c0.53,0.87,0.81,1.79,0.81,2.75c0,5-7.74,9.06-17.28,9.06 c-9.54,0-17.28-4.06-17.28-9.06c0-0.96,0.29-1.88,0.81-2.75c2.22,3.66,8.75,6.31,16.47,6.31 C113.32,105.59,119.84,102.94,122.07,99.28L122.07,99.28L122.07,99.28L122.07,99.28z M60.04,83.04l4.5,15.63 c3.48-7.32,7.11-14.59,7.93-22.9c-1.38-1.62-2.84-3.76-4.11-5.62c-0.38-0.55-0.73-1.07-1.07-1.55c-2.79,2.04-6.13,3.32-10.41,3.3 c-4.61-0.01-8.15-1.65-11.09-4.14c-0.02,0.03-0.04,0.06-0.06,0.09c-0.48,0.66-1.01,1.44-1.59,2.29c-1.08,1.59-2.3,3.37-3.49,4.87 c1.54,9.63,5.24,16.41,8.59,23.64l4.5-15.63C48.08,73.64,65.2,73.1,60.04,83.04L60.04,83.04z M69.08,67.14 c0.36,0.51,0.76,1.1,1.19,1.72c0.79,1.16,1.66,2.44,2.53,3.6c1.68,1.45,4.25,2.58,7.22,3.53C78.08,80.39,77,85.24,77,90.35 c0,7.4,2.26,14.28,6.13,19.98H56.9H6.19c-3.88-0.29-5.85-2.3-6.19-5.78l1.34-6c0.38-4.92,1.76-8.79,4-11.76 c1.48-1.96,3.32-3.4,5.36-4.53c6.07-3.38,21.77-4.51,28.47-9.04c1.05-1.35,2.12-2.94,3.1-4.36c0.6-0.88,1.16-1.7,1.63-2.34 c0.08-0.11,0.17-0.2,0.29-0.28c-2.47-2.54-4.46-5.61-6.35-8.62l-5.1-8.12c-1.87-2.79-2.83-5.32-2.9-7.41 c-0.03-0.98,0.14-1.87,0.5-2.66c0.38-0.82,0.96-1.51,1.76-2.04c0.37-0.25,0.78-0.46,1.24-0.63c-0.33-4.4-0.45-9.95-0.24-14.59 c0.11-1.1,0.32-2.21,0.63-3.3c1.31-4.66,4.58-8.41,8.62-10.98c1.42-0.91,2.99-1.66,4.64-2.26C49.9,4.56,48.48,0.08,51.73,0 c7.62-0.17,20.1,6.27,24.97,11.54c2.83,3.07,4.61,7.12,4.99,12.5l-0.32,13.24l0,0c1.42,0.43,2.32,1.32,2.69,2.78 c0.41,1.61-0.04,3.88-1.4,6.97l0,0c-0.03,0.05-0.05,0.11-0.08,0.17l-5.82,9.58c-2.24,3.69-4.51,7.39-7.56,10.23L69.08,67.14 L69.08,67.14L69.08,67.14z"
        />
      </g>
    </svg>
  ),
  Reward: (
    <svg xmlns="http://www.w3.org/2000/svg" width="144.48" height="192.349" viewBox="0 0 144.48 192.349">
      <path
        id="Reward-Icon-SVG-093kdf"
        d="M85.751,191.206a4.685,4.685,0,0,1-3.4-2.979l-10.61-29.7L61.1,188.223a4.7,4.7,0,0,1-3.591,3.02,2.431,2.431,0,0,1-.882.106A4.791,4.791,0,0,1,53.1,189.8l-16-18.175-23.8,3.758a4.631,4.631,0,0,1-4.387-1.6,4.8,4.8,0,0,1-.791-4.67l16.042-44.8a15.108,15.108,0,0,1-12.883-16.25l.259-2.793a5.387,5.387,0,0,0-2.474-5.09l-2.28-1.486a15.127,15.127,0,0,1-4.67-20.331L3.565,76a5.477,5.477,0,0,0-.007-5.68L2.13,67.98A15.053,15.053,0,0,1,6.779,47.726l2.232-1.549a5.411,5.411,0,0,0,2.533-5.108l-.263-2.8A14.931,14.931,0,0,1,24.287,22.082l2.639-.425a5.686,5.686,0,0,0,4.56-3.572l.944-2.5a14.985,14.985,0,0,1,18.7-9.113l2.627.875a5.585,5.585,0,0,0,5.575-1.259l2-1.9a14.981,14.981,0,0,1,20.781,0l2,1.921A5.521,5.521,0,0,0,89.63,7.354l2.621-.875A15.022,15.022,0,0,1,111.008,15.6l.958,2.5a5.607,5.607,0,0,0,4.495,3.543l2.752.446a14.825,14.825,0,0,1,12.9,16.177l-.22,2.763a5.451,5.451,0,0,0,2.448,5.116l2.332,1.592a15,15,0,0,1,4.589,20.228l-1.383,2.346a5.518,5.518,0,0,0,0,5.71l1.391,2.353a15.073,15.073,0,0,1-4.607,20.32l-2.332,1.5a5.441,5.441,0,0,0-2.441,5.083l.227,2.811a15.015,15.015,0,0,1-12.839,16.239l16.044,44.807a4.742,4.742,0,0,1-.875,4.7,4.55,4.55,0,0,1-4.352,1.544l-23.8-3.751L90.37,189.775a4.95,4.95,0,0,1-3.554,1.574A3.313,3.313,0,0,1,85.751,191.206ZM84.1,140.243l-1.988,1.9a14.16,14.16,0,0,1-5.072,3.188l11.5,32.123,12.411-14.058a4.767,4.767,0,0,1,4.293-1.548l18.446,2.99-12.418-34.717-.263.706a15.022,15.022,0,0,1-18.739,9.044l-2.635-.882a5.779,5.779,0,0,0-1.674-.247A5.638,5.638,0,0,0,84.1,140.243Zm-41.649,23.1,12.414,14.106L66.4,145.323a14.34,14.34,0,0,1-5.09-3.2l-1.987-1.889A5.787,5.787,0,0,0,53.708,139l-2.561.857a15,15,0,0,1-18.716-9.025l-.289-.751-12.433,34.75,19.232-3.015A4.86,4.86,0,0,1,42.448,163.344Zm23.412-29.952,2.006,1.932a5.686,5.686,0,0,0,7.729-.018l1.98-1.9a14.9,14.9,0,0,1,15.061-3.374l2.6.864a5.73,5.73,0,0,0,6.95-3.448l.951-2.518a15.058,15.058,0,0,1,12.041-9.618l2.723-.351a5.567,5.567,0,0,0,4.816-6.035l-.26-2.785a15.071,15.071,0,0,1,6.687-13.885l2.338-1.5a5.616,5.616,0,0,0,1.677-7.554l-1.38-2.331a14.7,14.7,0,0,1,0-15.4l1.383-2.339a5.636,5.636,0,0,0-1.7-7.554l-2.29-1.475a15.071,15.071,0,0,1-6.717-13.9l.26-2.789a5.608,5.608,0,0,0-4.86-6.039l-2.653-.337A14.949,14.949,0,0,1,103.135,21.4l-.955-2.522a5.552,5.552,0,0,0-6.953-3.348l-2.6.87a15.165,15.165,0,0,1-15.043-3.461l-2.005-1.925a5.667,5.667,0,0,0-7.726.014l-1.984,1.9a15.131,15.131,0,0,1-15.031,3.474L48.2,15.527a5.472,5.472,0,0,0-6.895,3.341l-1.024,2.566a14.9,14.9,0,0,1-12.048,9.6l-2.7.345a5.684,5.684,0,0,0-4.817,6.038l.267,2.775A15.056,15.056,0,0,1,14.3,54.083l-2.338,1.5a5.614,5.614,0,0,0-1.687,7.528l1.4,2.372a14.931,14.931,0,0,1-.011,15.379L10.281,83.2a5.608,5.608,0,0,0,1.7,7.558l2.291,1.471a15.081,15.081,0,0,1,6.716,13.9l-.271,2.8a5.651,5.651,0,0,0,4.828,6.024l2.694.344A15.049,15.049,0,0,1,40.3,124.937l.992,2.489a5.586,5.586,0,0,0,6.928,3.462l2.6-.864a12.693,12.693,0,0,1,4.67-.787A15.048,15.048,0,0,1,65.859,133.392ZM53.035,99.67A8.574,8.574,0,0,1,49.6,91.084l1.768-10.35L43.8,73.385a8.736,8.736,0,0,1-2.2-9.117,8.636,8.636,0,0,1,7.122-5.947L59.11,56.813,63.828,47.3a8.816,8.816,0,0,1,7.913-4.941A8.907,8.907,0,0,1,79.613,47.3l4.724,9.534,10.406,1.493a8.841,8.841,0,0,1,4.915,15.042l-7.58,7.371,1.771,10.376a8.669,8.669,0,0,1-3.569,8.615,8.913,8.913,0,0,1-9.215.725l-9.428-4.945-9.227,4.926a9.13,9.13,0,0,1-4.135,1.007A8.628,8.628,0,0,1,53.035,99.67ZM67.455,61.3a8.732,8.732,0,0,1-6.592,4.831l-9.5,1.383,6.848,6.65a8.8,8.8,0,0,1,2.533,7.81l-1.622,9.5,8.5-4.545a9.047,9.047,0,0,1,8.2,0l8.5,4.538-1.661-9.493a8.9,8.9,0,0,1,2.536-7.807l6.877-6.643-9.49-1.387A8.916,8.916,0,0,1,75.946,61.3l-4.231-8.593Z"
        transform="translate(0.529 0.5)"
        stroke="rgba(0,0,0,0)"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </svg>
  ),
  Investment: (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.56 122.88">
      <title>finance</title>
      <path
        style={{ fillRule: 'evenodd' }}
        d="M55.75,47.8,53.19,36.07C61.64,37.65,74,51.24,81.85,62c-5.59,3.55-9,8.66-9,14.72a15.46,15.46,0,0,0,.21,2.57A36,36,0,0,0,61,77.26,34,34,0,0,0,45.46,80.8c-6.12,3.21-9.92,8.33-9.92,14.57a14.46,14.46,0,0,0,.87,5c-.11.32-.22.65-.31,1h0v0a14.12,14.12,0,0,0-.56,3.85,14.4,14.4,0,0,0,.83,4.85l-.22.68a14.31,14.31,0,0,0-.61,4A14.51,14.51,0,0,0,38,122.88l-.75,0c-11.88-.61-30.25-.59-35-12.78C-5.54,90.38,8.65,66.94,21.59,52.59a70.92,70.92,0,0,1,5.28-5.27c4.71-4.14,9.79-9,15.84-11.1l-5.85,10.9,8.5-11.27h4.48L55.75,47.8Zm19.84,64.56a4.65,4.65,0,0,1,.7,2.41c0,4.44-6.87,8-15.34,8s-15.35-3.6-15.35-8a4.7,4.7,0,0,1,.7-2.41c2,3.27,7.78,5.64,14.65,5.64s12.7-2.37,14.64-5.64Zm44.11-2.86a5.71,5.71,0,0,1,.86,3c0,5.44-8.43,9.86-18.81,9.86S83,117.89,83,112.45a5.67,5.67,0,0,1,.86-3c2.39,4,9.52,6.91,17.94,6.91s15.56-2.91,18-6.91Zm0-11.92a5.76,5.76,0,0,1,.86,3c0,5.44-8.43,9.86-18.81,9.86S83,106,83,100.53a5.72,5.72,0,0,1,.86-3c2.39,4,9.52,6.91,17.94,6.91s15.56-2.91,18-6.91ZM108.54,72.74l-.22,2.45-9.22-.8a8.45,8.45,0,0,1,1.58,3.32l-2.22-.2a7.55,7.55,0,0,0-1-2.18,4.54,4.54,0,0,0-1.91-1.72l.17-2,12.83,1.11Zm-6.79-3.83c8.53,0,15.45,2.72,15.45,6.06S110.28,81,101.75,81,86.3,78.31,86.3,75s6.92-6.06,15.45-6.06Zm0-2c10.38,0,18.81,4.42,18.81,9.86s-8.43,9.86-18.81,9.86S83,82.2,83,76.76s8.42-9.86,18.8-9.86Zm18,19.11a5.69,5.69,0,0,1,.8,2.83c0,5.44-8.43,9.86-18.81,9.86S83,94.28,83,88.84A5.55,5.55,0,0,1,83.74,86c2.32,4.06,9.5,7,18,7s15.69-3,18-7ZM66.49,92.09l-.18,2-7.53-.66a6.94,6.94,0,0,1,1.29,2.71L58.26,96a6,6,0,0,0-.82-1.78,3.78,3.78,0,0,0-1.56-1.4L56,91.18l10.47.91ZM61,89c7,0,12.61,2.22,12.61,5s-5.65,5-12.61,5-12.61-2.22-12.61-5S54,89,61,89Zm0-1.64c8.47,0,15.34,3.61,15.34,8.05s-6.87,8-15.34,8-15.35-3.6-15.35-8S52.48,87.32,61,87.32Zm14.69,15.6a4.59,4.59,0,0,1,.65,2.31c0,4.43-6.87,8-15.34,8s-15.35-3.61-15.35-8a4.56,4.56,0,0,1,.65-2.31c1.89,3.31,7.75,5.73,14.7,5.73s12.8-2.42,14.69-5.73ZM42.34,20.3C40.52,14.93,38.88,9.5,37.5,4c5.16-5.66,25.1-4.91,30.83-.09L63,16.52c2.86-3.76,3.82-5.3,5.52-7.39a17.17,17.17,0,0,1,2,1.57c1.51,1.37,2.86,2.88,3.13,5a5.16,5.16,0,0,1-1.43,4.17L60.09,34.05a26.61,26.61,0,0,1-4.59-1.16c.69-1.63,1.53-3.42,2.22-5l-4.44,4.79a16.54,16.54,0,0,0-11.8,1.44L29.13,19.25a4.1,4.1,0,0,1-1.07-2.66c0-3.58,5.35-6.67,8.15-7.84L42.34,20.3Z"
      />
    </svg>
  ),
  Dropdown: (
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="1.41415"
        y1="1.25378"
        x2="7.61406"
        y2="7.48262"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="14.3672"
        y1="1.41414"
        x2="8.07151"
        y2="7.84132"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LeftArr: (
    <svg viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="0.75"
        y1="-0.75"
        x2="7.65232"
        y2="-0.75"
        transform="matrix(-0.712358 0.701816 -0.709083 -0.705125 6.91455 0.457031)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="0.75"
        y1="-0.75"
        x2="7.81536"
        y2="-0.75"
        transform="matrix(-0.718058 -0.695983 0.703523 -0.710672 7.89404 11.5767)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  RightArr: (
    <svg viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="0.75"
        y1="-0.75"
        x2="7.64532"
        y2="-0.75"
        transform="matrix(0.712358 -0.701816 0.709083 0.705125 1.24463 12.5967)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="0.75"
        y1="-0.75"
        x2="7.80841"
        y2="-0.75"
        transform="matrix(0.718641 0.695381 -0.704118 0.710083 0.265625 1.49463)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
} as { [key: string]: JSX.Element };

export default Icon;
